export const useImageListData = () => {
  const config = useRuntimeConfig()
  const transform = (response) => {
    const { sanitize } = useUtils();

    return {
      imageList: sanitize(response.data.attributes.imageList),
    }
  }    
  const getImageList = async (deep = true) => {        
    const url = `/api/image-list`;
    
    if (config.public.nuxtEnvironment === 'production') {
      return await useFetch(url, {
        method: 'GET',
        baseURL: config.public.nuxtAPIUrl,      
        transform: transform
      });
    }

    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
    
  }
    
    return {
      getImageList,
    }
}